import { render, staticRenderFns } from "./CardapioTurma.vue?vue&type=template&id=ed9dbc04&scoped=true&"
import script from "./CardapioTurma.vue?vue&type=script&lang=js&"
export * from "./CardapioTurma.vue?vue&type=script&lang=js&"
import style0 from "./CardapioTurma.vue?vue&type=style&index=0&id=ed9dbc04&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed9dbc04",
  null
  
)

export default component.exports